import React, { useEffect, useState } from 'react';
import { getCarrierScacs } from 'utils/OrderWebAPIUtils';
import { Button, Label, Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue, } from '@cargomatic/ui';
import { Trash } from 'lucide-react';
import { uniqBy } from 'lodash';
import FormGrid from './FormGrid';
export default function SteamshipRailroadRateConditionField({ condition, onChange, onRemove, }) {
    const [items, setItems] = useState([]);
    const { criteria: value } = condition;
    function handleRemove() {
        onRemove(condition);
    }
    function handleChange(criteria) {
        onChange(Object.assign(Object.assign({}, condition), { criteria }));
    }
    async function fetchData() {
        let { entity: { OCEAN_SCAC_CODES: oceanScacs }, } = await getCarrierScacs();
        setItems(uniqBy(oceanScacs, (item) => item.ocean_scac));
    }
    useEffect(() => {
        fetchData();
    }, []);
    return (React.createElement(FormGrid, null,
        React.createElement(Label, { className: "w-48" }, "Steamship/Railroad"),
        React.createElement(Select, { className: "flex-1", value: value, onValueChange: handleChange },
            React.createElement(SelectTrigger, { className: "", valu: true },
                React.createElement(SelectValue, { placeholder: "Steamship/Railroad" })),
            React.createElement(SelectContent, null,
                React.createElement(SelectGroup, null,
                    React.createElement(SelectLabel, null, "Steamship/Railroad"),
                    items.map((item) => (React.createElement(SelectItem, { value: item.ocean_scac, key: item.ocean_scac }, item.carrier)))))),
        React.createElement("div", null,
            React.createElement(Button, { variant: "icon", onClick: handleRemove },
                React.createElement(Trash, { className: "w-3.5 h-3.5" })))));
}
